import {Box, Card, CardContent, Pagination, Stack, Typography} from '@mui/material';
import {Question} from '@cp/model';
import AdminQuestionListEmpty from './AdminQuestionListEmpty';
import AdminQuestionListItem from './AdminQuestionListItem';

export interface AdminQuestionListProps {
  questions: Question[];
  currentPage: number;
  totalPages: number;
  startIndex: number;
  loading: boolean;
  moduleId: string;
  onQuestionClick: (question: Question) => void;
  onPageChange: (page: number) => void;
}

export default function AdminQuestionList({
  questions,
  currentPage,
  totalPages,
  startIndex,
  loading,
  moduleId,
  onQuestionClick,
  onPageChange,
}: AdminQuestionListProps) {
  if (questions.length === 0 && !loading) {
    return <AdminQuestionListEmpty />;
  }

  return (
    <Card>
      <CardContent>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2,
            minHeight: questions.length == 0 ? '100px' : 'auto',
          }}
        >
          <Typography variant="h6" sx={{color: '#1B263B'}}>
            Questions ({questions.length})
          </Typography>
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={(_, page) => onPageChange(page)}
            color="primary"
          />
        </Box>

        <Stack spacing={2}>
          {questions.map((question: Question, index: number) => (
            <AdminQuestionListItem
              key={question.id}
              question={question}
              index={index}
              startIndex={startIndex}
              moduleId={moduleId}
              onClick={onQuestionClick}
            />
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
}
